<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="iconState"
                :options="iconStateOptions"
                native
                @input="onIconStateInput"
            />
        </template>

        <template slot="primary">
            <dropdown
                :value="iconImg"
                :options="iconImgOptions"
                native
                @input="onIconImgInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

export default {
    name: 'control-drawer-icon',

    mixins: [baseOption],

    data() {
        return {
            displayName: 'Drawer Icon',
            iconState: 'collapsed',
            iconImgCollapsed: '',
            iconImgExpanded: '',
            iconStateOptions: [
                { text: 'Collapsed', value: 'collapsed' },
                { text: 'Expanded', value: 'expanded' },
            ],
            iconImgOptions: [
                { text: 'None', value: '' },
                { text: 'Chevron Up', value: 'chevron-up' },
                { text: 'Chevron Down', value: 'chevron-down' },
                { text: 'Chevron Circle Up', value: 'chevron-circle-up' },
                { text: 'Chevron Circle Down', value: 'chevron-circle-down' },
                { text: 'Plus', value: 'plus' },
                { text: 'Minus', value: 'minus' },
                { text: 'Plus Circle', value: 'plus-circle' },
                { text: 'Minus Circle', value: 'minus-circle' },
            ],
        };
    },

    computed: {
        iconImg() {
            return this.iconState === 'collapsed' ? this.iconImgCollapsed : this.iconImgExpanded;
        },
    },

    watch: {
        state() {
            this.setSelectedValue();
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onIconStateInput(newState) {
            this.iconState = newState;
        },

        onIconImgInput(newValue) {
            this.selectedElements[0].setElementData(`drawer-icon-${ this.iconState }`, newValue);
            this.$root.$emit(`flex::option::drawer-icon-${ this.iconState }`);
        },

        // set default icon img:
        onSelectedElement() {
            const iconImgCollapsed = this.selectedElements[0].getElementData('drawer-icon-collapsed');
            const iconImgExpanded = this.selectedElements[0].getElementData('drawer-icon-expanded');

            this.iconImgCollapsed = iconImgCollapsed || 'chevron-down';
            this.iconImgExpanded = iconImgExpanded || 'chevron-up';
        },
    },
};
</script>
